import SvgIcon from '@mui/material/SvgIcon';

function FeelLighterIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 29 32">
      <path fill="currentColor" d="M7.5 16.0625C7.49996 17.2847 6.71627 18.3269 5.625 18.7139V22.625H14.0625C11.4779 22.625 9.37507 20.5221 9.375 17.9375C9.375 15.3528 11.4778 13.25 14.0625 13.25C16.6471 13.2501 18.75 15.3529 18.75 17.9375C18.7499 20.5221 16.6471 22.6249 14.0625 22.625H22.5V18.7139C21.4088 18.3269 20.625 17.2847 20.625 16.0625V13.25H23.4375C26.0222 13.25 28.125 15.3528 28.125 17.9375V28.25H20.625V32H7.5V28.25H0V17.9375C0 15.3529 2.1029 13.2501 4.6875 13.25H7.5V16.0625ZM20.8369 7.625H17.8125V11.375H10.3125V7.625H7.28809L14.0625 0L20.8369 7.625Z" />
    </SvgIcon>
  );
}

export default FeelLighterIcon;
